export default "__VITE_ASSET__BR7XI3sv__"